import { NgModule } from '@angular/core';
import {RouterModule} from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { IdentityRoutingModule } from './identity-routing';
import { IdentityComponent } from './identity.component';
import { UserIdentityComponent } from './identity-list/user-identity/user-identity.component';
import { PersonalDataComponent } from './personal-data/personal-data.component';
import { IdentityListComponent } from './identity-list/identity-list.component';
import { EditIdentityComponent } from './edit-identity/edit-identity.component';
import { EditCredentialsComponent } from './edit-credentials/edit-credentials.component';
import { AccessLogsComponent } from './access-logs/access-logs.component';
import { RevokeIdentityComponent } from './revoke-identity/revoke-identity.component';
import { ResumeIdentityComponent } from './resume-identity/resume-identity.component';
import { SuspendIdentityComponent } from './suspend-identity/suspend-identity.component';
import { ActivateIdentityComponent } from './identity-list/user-identity/activate-identity/activate-identity.component';
import { RequestsComponent } from './requests/requests.component';
import { DraftComponent } from './draft/draft.component';
import { CompileDraftComponent } from './compile-draft/compile-draft.component';
import { CompleteRequestComponent } from './complete-request/complete-request.component';
import {QrCodeAssociationComponent} from "./edit-credentials/qr-code-association/qr-code-association.component";



@NgModule({
  declarations: [
    IdentityComponent,
    UserIdentityComponent,
    PersonalDataComponent,
    IdentityListComponent,
    IdentityComponent,
    UserIdentityComponent,
    PersonalDataComponent,
    EditIdentityComponent,
    EditCredentialsComponent,
    AccessLogsComponent,
    RevokeIdentityComponent,
    SuspendIdentityComponent,
    ResumeIdentityComponent,
    ActivateIdentityComponent,
    RequestsComponent,
    DraftComponent,
    CompileDraftComponent,
    CompleteRequestComponent,
  ],
  imports: [
    CommonModule,
    IdentityRoutingModule,
    SharedModule,
    RouterModule,
    QrCodeAssociationComponent,
  ],
  exports: [
    IdentityListComponent,
    UserIdentityComponent
  ]
})
export class IdentityModule { }
